/* pdp-drawer.js — los drawers de la ficha (lote pdp-reassurance, A8, 3 nov
   2026). Sin dependencias. El marcado es `snippets/pdp-drawer.liquid` y sus
   seis contenidos; el aspecto, `assets/pdp-drawer.css`.

   Qué hace:
     · Convierte los disparadores. Sin JS son `<a>` a la página de siempre
       (devoluciones, país, `mailto:`, /pages/cabin-check); aquí cada `<a>`
       con `data-track="drawer:<clave>"` cuyo drawer existe pasa a ser un
       `<button class="lnk">` con el mismo contenido, las mismas clases y
       los mismos `data-*`. El resumen «Email me when it’s in» (un
       `<summary>`) se queda, pero abre el drawer en vez del `<details>`.
       «Add to bag» lo abre `assets/v10-product.js` con `as.pdpDrawer.bag()`.
     · Abre y cierra: un drawer a la vez (abrir otro cierra el anterior);
       `Esc`, «× Close», «← Keep looking» y el velo cierran; el foco entra
       al abrir y vuelve al disparador al cerrar; la página sin scroll
       mientras está abierto (`html.pdp-dlock`, con el hueco de la barra
       reservado: la columna no se mueve); la URL no cambia (sin hash);
       sin animación (regla 6).
     · Bag: el drawer no está en el DOM hasta añadir; se clona de su
       `<template>` y se pinta con `/cart.js`. Cantidades por
       `/cart/change.js`, sin recargar; el «Bag (n)» del header y el título
       del drawer siguen a la bolsa.
     · Deliver to: la fecha de cada país con la regla de la línea de
       entrega (`as.delivery`, de `v10-product.js`); elegir uno guarda
       `as_country` (cookie y localStorage), cierra y avisa con
       `pdp:country` (la línea de entrega y la del Bag se rehacen).
     · Ask: el formulario de contacto por `fetch`; al enviarse, «Sent.» y
       nada más.

   `as.pdpDrawer` = { open(key, from), close(), bag(cart, info), country() } */
(function (w, d) {
  'use strict';
  var as = w.acaciasupplies = w.acaciasupplies || {};
  if (as.pdpDrawer) return;
  var wrap = d.querySelector('[data-pdp-drawers]');
  if (!wrap) return;

  var root = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
  var veil = wrap.querySelector('[data-pdp-veil]');
  var html = d.documentElement;
  var current = null;
  var opener = null;

  function drawer(key) { return wrap.querySelector('[data-pdp-drawer="' + key + '"]'); }

  /* ── Abrir y cerrar ───────────────────────────────────────────────────── */
  function close() {
    if (!current) return;
    current.hidden = true;
    if (veil) veil.hidden = true;
    html.classList.remove('pdp-dlock');
    var back = opener;
    current = null;
    opener = null;
    if (back && back.isConnected) back.focus({ preventScroll: true });
  }
  function open(key, from) {
    var el = drawer(key);
    if (!el) return false;
    if (current && current !== el) {
      current.hidden = true;
    }
    if (!current) opener = from || d.activeElement;
    current = el;
    el.hidden = false;
    if (veil) veil.hidden = false;
    html.classList.add('pdp-dlock');
    var focus = el.querySelector('[data-pdp-drawer-close]') || el;
    focus.focus({ preventScroll: true });
    return true;
  }
  if (veil) veil.addEventListener('click', close);
  wrap.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[data-pdp-drawer-close]');
    if (c) { e.preventDefault(); close(); }
  });
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && current) { e.preventDefault(); e.stopPropagation(); close(); }
  }, true);
  /* El foco no sale del drawer abierto con Tab. */
  d.addEventListener('focusin', function (e) {
    if (!current || current.contains(e.target)) return;
    var first = current.querySelector('[data-pdp-drawer-close]') || current;
    first.focus({ preventScroll: true });
  });

  /* ── Los disparadores: `<a>` → `<button class="lnk">` ───────────────── */
  function toButton(a) {
    var b = d.createElement('button');
    b.type = 'button';
    Array.prototype.forEach.call(a.attributes, function (at) {
      if (at.name === 'href' || at.name === 'target' || at.name === 'rel') return;
      b.setAttribute(at.name, at.value);
    });
    b.classList.add('lnk');
    while (a.firstChild) b.appendChild(a.firstChild);
    a.parentNode.replaceChild(b, a);
    return b;
  }
  Array.prototype.forEach.call(d.querySelectorAll('a[data-track^="drawer:"]'), function (a) {
    var key = a.getAttribute('data-track').slice('drawer:'.length);
    if (!drawer(key)) return;
    var b = toButton(a);
    b.setAttribute('aria-haspopup', 'dialog');
    b.setAttribute('aria-controls', 'pdp-drawer-' + key);
    b.addEventListener('click', function (e) {
      e.preventDefault();
      if (key === 'country') paintCountries();
      open(key, b);
    });
  });
  /* «Email me when it’s in»: el `<summary>` abre el drawer, no el `<details>`. */
  Array.prototype.forEach.call(d.querySelectorAll('summary[data-track="drawer:notify"]'), function (s) {
    if (!drawer('notify')) return;
    s.setAttribute('aria-haspopup', 'dialog');
    s.addEventListener('click', function (e) {
      e.preventDefault();
      open('notify', s);
    });
  });

  /* ── Deliver to ───────────────────────────────────────────────────────── */
  var COUNTRY_KEY = 'as_country';
  function readCountry() {
    var v = null;
    try { v = w.localStorage.getItem(COUNTRY_KEY); } catch (err) { console.warn('pdp-drawer: localStorage unavailable', err); }
    if (!v) {
      var m = /(?:^|;\s*)as_country=([A-Z]{2})/.exec(d.cookie || '');
      if (m) v = m[1];
    }
    return v && /^[A-Z]{2}$/.test(v) ? v : null;
  }
  function saveCountry(iso) {
    try { w.localStorage.setItem(COUNTRY_KEY, iso); } catch (err) { console.warn('pdp-drawer: localStorage unavailable', err); }
    d.cookie = COUNTRY_KEY + '=' + iso + '; path=/; max-age=31536000; samesite=lax';
  }
  function countryRow(iso) {
    var c = drawer('country');
    return c ? c.querySelector('[data-pdp-country="' + iso + '"]') : null;
  }
  /* La zona de un país: nombre, tránsito, tarifa (si la zona la trae). */
  function zoneOf(iso) {
    var r = countryRow(iso);
    if (!r) return null;
    var tmin = r.getAttribute('data-transit-min');
    var tmax = r.getAttribute('data-transit-max');
    return {
      iso: iso,
      name: r.getAttribute('data-name') || iso,
      tmin: /^\d+$/.test(tmin) ? +tmin : null,
      tmax: /^\d+$/.test(tmax) ? +tmax : null,
      rate: r.getAttribute('data-rate') || '',
      free: r.getAttribute('data-free') || ''
    };
  }
  function paintCountries() {
    var c = drawer('country');
    var dl = as.delivery;
    var now = new Date();
    var sel = (as.deliveryCountry && as.deliveryCountry()) || null;
    if (!c) return;
    Array.prototype.forEach.call(c.querySelectorAll('[data-pdp-country]'), function (r) {
      var iso = r.getAttribute('data-pdp-country');
      var z = zoneOf(iso);
      var out = r.querySelector('[data-pdp-country-when]');
      var bits = [];
      if (dl && z && z.tmin != null && z.tmax != null) {
        var e = dl.estimate(now, dl.cutoff(), Math.min(z.tmin, z.tmax), Math.max(z.tmin, z.tmax), dl.holidays());
        if (e) bits.push(dl.range(e));
      }
      if (z && z.rate) bits.push(money(+z.rate * 100));
      if (out) out.textContent = bits.join(' · ');
      if (sel) r.setAttribute('aria-checked', iso === sel ? 'true' : 'false');
    });
  }
  var cd = drawer('country');
  if (cd) {
    cd.addEventListener('click', function (e) {
      var r = e.target.closest && e.target.closest('[data-pdp-country]');
      if (!r) return;
      var iso = r.getAttribute('data-pdp-country');
      saveCountry(iso);
      Array.prototype.forEach.call(cd.querySelectorAll('[data-pdp-country]'), function (x) {
        x.setAttribute('aria-checked', x === r ? 'true' : 'false');
      });
      d.dispatchEvent(new CustomEvent('pdp:country', { detail: zoneOf(iso) }));
      close();
    });
  }

  /* ── Ask about this piece ─────────────────────────────────────────────── */
  var ask = wrap.querySelector('form[data-pdp-ask]');
  if (ask) {
    ask.addEventListener('submit', function (e) {
      if (!w.fetch || !w.FormData) return;
      e.preventDefault();
      var msg = ask.querySelector('[data-pdp-ask-msg]');
      var btn = ask.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      var body = new FormData(ask);
      fetch(ask.getAttribute('action') || (root + 'contact'), { method: 'POST', body: body, credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          var done = d.createElement('p');
          done.className = 'pdp-dr__sent';
          done.setAttribute('role', 'status');
          done.textContent = 'Sent.';
          ask.parentNode.replaceChild(done, ask);
        })
        .catch(function (err) {
          console.error('pdp-drawer: the question could not be sent', err);
          if (msg) msg.textContent = 'It couldn’t be sent. Try again.';
          if (btn) btn.disabled = false;
        });
    });
  }

  /* ── Bag ──────────────────────────────────────────────────────────────── */
  var bagEl = null;
  var bagInfo = {};
  function money(cents) {
    var n = Math.round(+cents || 0);
    var rest = n % 100;
    var int = String((n - rest) / 100).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return int + (rest ? '.' + String(rest).padStart(2, '0') : '') + ' €';
  }
  function setCounts(n) {
    d.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = n > 0 ? String(n) : ''; });
  }
  function ensureBag() {
    if (bagEl) return bagEl;
    var tpl = wrap.querySelector('template[data-pdp-drawer-tpl="bag"]');
    if (!tpl) return null;
    bagEl = tpl.content.firstElementChild.cloneNode(true);
    wrap.appendChild(bagEl);
    bagEl.addEventListener('click', function (e) {
      var q = e.target.closest && e.target.closest('[data-q]');
      if (!q) return;
      var li = q.closest('[data-key]');
      if (!li) return;
      var qty = Math.max(0, (+li.getAttribute('data-qty') || 0) + (+q.getAttribute('data-q')));
      q.disabled = true;
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: li.getAttribute('data-key'), quantity: qty })
      })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (cart) { paintBag(cart); })
        .catch(function (err) {
          console.error('pdp-drawer: the quantity could not change', err);
          q.disabled = false;
        });
    });
    return bagEl;
  }
  function shipLine() {
    var z = as.deliveryZone ? as.deliveryZone() : null;
    var parts = ['VAT included'];
    if (z && z.name) {
      var s = 'shipping to ' + z.name;
      if (z.rate) s += ' ' + money(+z.rate * 100);
      parts.push(s);
      if (z.free) parts.push('free from ' + money(+z.free * 100));
    }
    return parts.join(' · ');
  }
  function paintBag(cart) {
    var el = ensureBag();
    if (!el || !cart) return;
    var n = cart.item_count || 0;
    setCounts(n);
    var title = el.querySelector('[data-pdp-drawer-title]');
    if (title) title.textContent = 'Bag (' + n + ')';
    var list = el.querySelector('[data-pdp-bag-lines]');
    var tpl = el.querySelector('template[data-pdp-bag-line]');
    if (list && tpl) {
      list.textContent = '';
      (cart.items || []).forEach(function (it) {
        var li = tpl.content.firstElementChild.cloneNode(true);
        var mine = bagInfo.productId && String(it.product_id) === String(bagInfo.productId);
        li.setAttribute('data-key', it.key);
        li.setAttribute('data-qty', it.quantity);
        var f = function (k) { return li.querySelector('[data-f="' + k + '"]'); };
        /* Regla 2: de las líneas que no son esta ficha, solo tipo, cantidad y precio. */
        f('name').textContent = mine ? bagInfo.title : (it.product_type || '');
        var color = '';
        if (mine && bagInfo.colorIndex >= 0 && it.options_with_values && it.options_with_values[bagInfo.colorIndex]) {
          color = it.options_with_values[bagInfo.colorIndex].value;
        }
        f('meta').textContent = mine ? [bagInfo.brand, color].filter(Boolean).join(' · ') : '';
        if (mine && it.image) {
          f('img').src = it.image + (it.image.indexOf('?') < 0 ? '?' : '&') + 'width=160';
          f('img').alt = bagInfo.title || '';
        }
        f('qty').textContent = String(it.quantity);
        f('price').textContent = money(it.final_line_price != null ? it.final_line_price : it.line_price);
        list.appendChild(li);
      });
    }
    var total = el.querySelector('[data-pdp-bag-total]');
    if (total) total.textContent = money(cart.total_price);
    var ship = el.querySelector('[data-pdp-bag-ship]');
    if (ship) ship.textContent = shipLine();
    var when = el.querySelector('[data-pdp-bag-when]');
    var dl = d.querySelector('[data-pdp-delivery-line]');
    if (when) {
      when.textContent = dl ? dl.textContent : '';
      when.hidden = !when.textContent;
    }
  }
  function bag(cart, info) {
    if (info) bagInfo = info;
    if (!ensureBag()) return false;
    paintBag(cart);
    return open('bag', d.querySelector('[data-v10-cta]'));
  }
  d.addEventListener('pdp:country', function () {
    if (bagEl) {
      var ship = bagEl.querySelector('[data-pdp-bag-ship]');
      if (ship) ship.textContent = shipLine();
    }
  });
  d.addEventListener('pdp:delivery', function () {
    if (!bagEl) return;
    var when = bagEl.querySelector('[data-pdp-bag-when]');
    var dl = d.querySelector('[data-pdp-delivery-line]');
    if (when) { when.textContent = dl ? dl.textContent : ''; when.hidden = !when.textContent; }
  });

  as.pdpDrawer = {
    open: open,
    close: close,
    bag: bag,
    isOpen: function () { return current ? current.getAttribute('data-pdp-drawer') : null; },
    country: readCountry,
    zone: zoneOf
  };
})(window, document);
